import { createContext, useCallback, useContext, useEffect, useState } from "react";
import ownerAPI from "../../../services/ownerApi";

const OwnerDashboardContext = createContext(null);

export function OwnerDashboardProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await ownerAPI.getDashboard();
      if (res.result !== 0) throw new Error(res.error || "Ошибка загрузки");
      setData(res);
    } catch (e) {
      setError(e.response?.data?.error || e.message || "Не удалось загрузить данные");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const value = {
    data,
    loading,
    error,
    reload,
    clubs: data?.clubs || [],
    user: data?.user || null,
  };

  return (
    <OwnerDashboardContext.Provider value={value}>
      {children}
    </OwnerDashboardContext.Provider>
  );
}

export function useOwnerDashboard() {
  const ctx = useContext(OwnerDashboardContext);
  if (!ctx) {
    throw new Error("useOwnerDashboard must be used within OwnerDashboardProvider");
  }
  return ctx;
}
